export default "__VITE_ASSET__1cc0f937__$_?nuxt_component=async__"